import React, { PropsWithChildren, useMemo } from 'react';
import { Container } from 'inversify';

interface IContainerContext {
  container: Container | null;
}

type ServiceProviderProps = PropsWithChildren<{
  container: Container;
}>;

export const InversifyContext = React.createContext<IContainerContext>({
  container: null,
});

function ServiceProvider({ container, children }: ServiceProviderProps) {
  const contextValue = useMemo<IContainerContext>(() => {
    return {
      container,
    };
  }, [container]);

  return (
    <InversifyContext.Provider value={contextValue}>{children}</InversifyContext.Provider>
  );
}

export default React.memo(ServiceProvider);
